import React, { useEffect, useState } from "react";
import { fetchCurrentWorkout } from "../../../api/userProfile";

const CurrentWorkoutPlan = ({ userId }) => {
  const [workoutPlan, setWorkoutPlan] = useState(null);

  let getCurrentWorkout;
  getCurrentWorkout = async () => {
    try {
      const response = await fetchCurrentWorkout(userId);
      setWorkoutPlan(response);
    } catch (error) {
      console.error("Error fetching workout plan:", error);
    }
  };

  useEffect(() => {
    if (userId) {
      getCurrentWorkout(userId).then();
    }
  }, [getCurrentWorkout, userId]);

  if (!workoutPlan) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <h6 className="text-left fw-bold">Current Workout Plan</h6>
      <div className="card mb-3">
        <div
          className="card-body d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <div className="row w-100">
            <div className="col-md-3 d-flex flex-column justify-content-left align-items-left">
              <div>Plan Name: </div>
              <b className="fs-6">{workoutPlan[0].planDetails.plan_name}</b>
            </div>

            <div className="col-md-9 d-flex justify-content-center align-items-center">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div className="progress w-75">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${workoutPlan.progress}%` }}
                    aria-valuenow={workoutPlan.progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <span>{workoutPlan.progress}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrentWorkoutPlan;
